import { type ReactElement, type ReactNode } from "react"
import { RootState } from "src/app/store";
import { useSelector } from "react-redux";

export interface DealerDetailedReportProps {
        invoiceNumber: string,
        children?: ReactNode
}

export function DealerDetailedReport(props: DealerDetailedReportProps): ReactElement {

        const { dealerLoading, dealerError, dealer } = useSelector((state: RootState) => state.dealer);
        const { endUserForDetailedReportsLoading, endUserForDetailedReportsError, endUserForDetailedReports } = useSelector((state: RootState) => state.endUserForDetailedReports);
        let dealerAddress = "";
        if ((dealer.Addresses.Address1.length > 0) && (dealer.Addresses.City.length > 0) && (dealer.Addresses.State.length > 0) && (dealer.Addresses.Country.length > 0)) {
                dealerAddress = dealer.Addresses.Address1 + ", " + dealer.Addresses.City + ", " + dealer.Addresses.State + " - " + dealer.Addresses.Country;
        }

        return <>
                <div className="flex flex-col items-center gap-8 m-12">
                        <div className="flex flex-row justify-between w-full">
                                <h2 className="flex flex-col justify-center gap-4">
                                        <div className="flex justify-center">
                                                <p>{dealer.Name}</p>
                                        </div>
                                        <div className="flex justify-center flex-wrap">
                                                <p>{dealerAddress}</p>
                                        </div>
                                        <div className="flex justify-center">
                                                <p>{dealer.CreatedAt}</p>
                                        </div>
                                </h2>
                                <h2 className="flex flex-col gap-4">
                                        <div className="flex gap-4">
                                                <p className="font-bold">Invoice Number:</p>
                                                <p>{props.invoiceNumber}</p>
                                        </div>
                                        <div className="flex gap-4">
                                                <p className="">Billing Cycle:</p>
                                                <p>{dealer.Name}</p>
                                        </div>
                                </h2>
                        </div>
                        {endUserForDetailedReports.map(endUser =>
                                <div className="block break-inside-avoid">
                                        <div className="flex w-full">
                                                <div className="flex-[0_1_15%]">
                                                        <div className="underline font-bold">EndUser ID:</div>
                                                        <div>{endUser.EndUserId}</div>
                                                </div>
                                                <div className="flex-[0_0_25%]">
                                                        <div className="underline font-bold">EndUser Name:</div>
                                                        <div>{endUser.Name}</div>
                                                </div>
                                                <div className="flex-[0_0_25%]">
                                                        <div className="underline font-bold">Instance Details:</div>
                                                        <div>{
                                                                endUser.snapShotDetails.map(snapShot =>
                                                                        <div>{snapShot.coreInstances.map(coreInstance => (
                                                                                <div>
                                                                                        <div>{snapShot.coreInstances.length + " DSX-Cloud System"}</div>
                                                                                        <div>{coreInstance.locationInstancesList.map(locationInstance => (
                                                                                                <div>{locationInstance.LocationName + " " + locationInstance.LocationNumber + " = " + locationInstance.LocationDoors + " Doors"}</div>
                                                                                        ))}</div>
                                                                                </div>
                                                                        ))}</div>
                                                                )
                                                        }</div>
                                                </div>
                                                <div className="flex-[0_0_35%]">
                                                        <div className="underline font-bold">Monthly Price:</div>
                                                        <div>
                                                                <div className="flex">
                                                                        <p>{endUser.billingDetails.LocationIncluded}</p>
                                                                </div>
                                                                <div className="flex">
                                                                        <p>{endUser.billingDetails.LocationPrice}</p>
                                                                </div>
                                                                <div className="flex">
                                                                        <p>{endUser.billingDetails.DoorFirstTierCharges}</p>
                                                                </div>
                                                                <div className="flex">
                                                                        <p>{endUser.billingDetails.DoorSecondTierCharges}</p>
                                                                </div>
                                                                <div className="flex">
                                                                        <p>{endUser.billingDetails.DoorThirdTierCharges}</p>
                                                                </div>
                                                                <div className="flex">
                                                                        <p>{endUser.billingDetails.TotalCharges}</p>
                                                                </div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>
                        )

                        }

                </div>
        </>
}
